export const MOST_SEARCHED = {
	generalAdult: {
		code: '1',
		description: 'Clínico Geral',
		formattedText: 'Clínico Geral',
		sub_code: '',
	},
	generalAdultOdonto: {
		code: '522',
		description: 'Odontologia Clínica',
		formattedText: 'Odontologia Clínica Geral',
		sub_code: '3',
	},
	generalPediatricOdonto: {
		code: '528',
		description: 'Odontopediatria',
		formattedText: 'Odontopediatria Geral',
		sub_code: '5',
	},
	generalPediatric: {
		code: '10',
		description: 'Pediatria',
		formattedText: 'Pediatria',
		sub_code: '',
	},
	renovationReceipt: {
		code: '222',
		description: 'RENOVAÇÃO DE RECEITAS',
		formattedText: 'RENOVAÇÃO DE RECEITAS',
		sub_code: '',
	},
	headache: {
		code: '800',
		description: 'DOR DE CABECA CEFALEIA',
		formattedText: 'DOR DE CABECA CEFALEIA',
		sub_code: '',
	},
	backache: {
		code: '610',
		description: 'DOR NAS COSTAS - LOMBALGIA',
		formattedText: 'DOR NAS COSTAS - LOMBALGIA',
		sub_code: '',
	},
	stomachache: {
		code: '611',
		description: 'DOR NO ESTOMAGO - REFLUXO',
		formattedText: 'DOR NO ESTOMAGO - REFLUXO',
		sub_code: '',
	},
};
